import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useEffect, useState } from 'react';

const siteUrl = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) || 'https://biffdigital.com';
const logoUrl = 'https://storage.helloreaddy.io/project_files/8cf86b48-d09c-4ec8-816e-12bbed2b078b/1e3fa9b9-1413-4092-84fc-01303456e9e9_compressed_Biff-Digital-Logo.webp';

const insights = [
  {
    date: 'Eylül 2026',
    tag: 'E-commerce',
    title: 'E-Ticarette Trafik Değil, Dönüşüm Kazandırır',
    desc: 'Mağazanıza gelen ziyaretçi sayısını artırmak yetmez. Asıl kazanç, o ziyaretçileri sepete ekleyip ödemeye geçiren dönüşüm yolculuğunda gizli. E-ticarette trafiği büyütmeden önce satış hunisini onarmak, reklam bütçenizi boşa harcamamanın ilk kuralıdır.',
  },
  {
    date: 'Ağustos 2026',
    tag: 'AI',
    title: 'Yapay Zekâ vs Yapay Zekâ',
    desc: 'Yapay zekâ artık herkesin elinde. Ama aynı araç herkesin eline geçince, ortaya aynılaşma çıkıyor. AI ile üretilen içerikler birbirine benzemeye başladığında, farkı yaratan şey aracın kendisi değil; onu kimin, hangi stratejiyle yönettiği oluyor.',
  },
  {
    date: 'Temmuz 2026',
    tag: 'Branding',
    title: 'Görünmek Yetmez. Doğru Algılanmak Gerekir.',
    desc: 'Görünür olmak kolay. Bütçe yeter. Asıl zor olan, göründüğünüz anda insanların zihninde doğru anlamı oluşturmak. Markanın söylediği ile insanların anladığı arasındaki fark, büyümenin görünmez engelidir.',
  },
  {
    date: 'Haziran 2026',
    tag: 'Growth',
    title: 'Reklam Bütçeniz Değil, Pazarlama Sisteminiz Yanlış Olabilir.',
    desc: 'Reklam çalışmıyorsa sorun her zaman reklamda değil. Ürün, fiyat, mesaj, hedef kitle, dönüşüm yolu — bunlardan biri tıkalıysa bütçeyi artırmak sadece zararı büyütür. Sistemi bütün olarak okumak gerekir.',
  },
  {
    date: 'Mayıs 2026',
    tag: 'Neuromarketing',
    title: 'Nöropazarlama Nedir?',
    desc: 'Nöropazarlama, insanların ne söylediğine değil, ne hissettiğine bakar. EEG, göz izleme ve biyometrik ölçümle, bir reklamın ya da tasarımın bilinçaltında nasıl bir tepki yarattığını ölçer. Tahmin etmek yerine ölçmek.',
  },
  {
    date: 'Nisan 2026',
    tag: 'Advertising',
    title: 'Performans Pazarlama Nedir?',
    desc: 'Performans pazarlama, bütçenin her kuruşunun karşılığını ölçtüğünüz pazarlamadır. Görünürlük değil, sonuç. Tıklama, dönüşüm, satış — her şey veriyle izlenir ve optimize edilir. Reklam vermek başka, büyümeyi yönetmek başka.',
  },
  {
    date: 'Mart 2026',
    tag: 'B2B',
    title: 'B2B Pazarlamada İnsanlar Neden Hemen Satın Almaz?',
    desc: 'B2B\'de kimse "sepete ekle" butonuna basmaz. Karar uzun, taraflar çok, risk yüksek. Bu yüzden B2B pazarlama; satış değil, güven ve otorite inşası üzerine kurulur. Doğru içerik, doğru zamanda, doğru kişiye ulaştığında satış kendiliğinden gelir.',
  },
  {
    date: 'Şubat 2026',
    tag: 'Strategy',
    title: 'Marka Stratejisi Nedir?',
    desc: 'Marka stratejisi logo değil, konumlandırmadır. Pazarda ne anlama geldiğiniz, kimin için ne çözdüğünüz ve neden sizi tercih etmesi gerektiği. Herkes marka ister; kimse konumlandırma yapmaz. Fark burada başlar.',
  },
  {
    date: 'Ocak 2026',
    tag: 'AI',
    title: 'GEO Nedir?',
    desc: 'GEO, Generative Engine Optimization. İnsanlar artık sadece Google\'da aramıyor; ChatGPT ve benzeri yapay zekâ asistanlarına soruyor. GEO, markanızın bu AI cevaplarında yer almasını sağlar. Aranan değil, bulunan marka olmak.',
  },
];

const categories = ['Tümü', 'Strategy', 'Growth', 'Advertising', 'Branding', 'AI', 'Neuromarketing', 'B2B', 'E-commerce'];

const blogSchemas = insights.map((item, i) => ({
  '@context': 'https://schema.org',
  '@type': 'BlogPosting',
  headline: item.title,
  description: item.desc,
  author: {
    '@type': 'Person',
    name: 'BIFF Digital Strateji Ekibi',
    jobTitle: 'Dijital Pazarlama Uzmanı',
    worksFor: {
      '@type': 'Organization',
      name: 'BIFF Digital',
      url: siteUrl,
    },
  },
  publisher: {
    '@type': 'Organization',
    name: 'BIFF Digital',
    logo: { '@type': 'ImageObject', url: logoUrl },
  },
  datePublished: ['2026-09-01', '2026-08-01', '2026-07-15', '2026-06-20', '2026-05-10', '2026-04-12', '2026-03-18', '2026-02-08', '2026-01-22'][i],
  dateModified: '2026-08-07',
  about: 'Dijital Pazarlama Sektör Trendleri',
  inLanguage: 'tr',
}));

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Ana Sayfa', item: siteUrl },
    { '@type': 'ListItem', position: 2, name: 'İçgörüler', item: `${siteUrl}/dijital-pazarlama-blog` },
  ],
};

const allSchemas = {
  '@context': 'https://schema.org',
  '@graph': [
    ...blogSchemas,
    breadcrumbSchema,
  ],
};

export default function Icgoruler() {
  const [activeCategory, setActiveCategory] = useState('Tümü');

  useEffect(() => {
    document.title = 'BIFF Digital | Dijital Pazarlama Blog - Sektör Trendleri ve İçgörüler';
  }, []);

  const filteredInsights = activeCategory === 'Tümü'
    ? insights
    : insights.filter((item) => item.tag === activeCategory);

  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(allSchemas) }}
      />
      <Navbar />
      <main className="pt-16 md:pt-20">
        {/* Header */}
        <section className="section-padding bg-background-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="mb-10 md:mb-14">
              <div className="flex items-center gap-3 mb-2">
                <p className="text-primary-500 font-bold text-sm tracking-widest uppercase">
                  GÜNCEL İÇGÖRÜLER
                </p>
                <span className="inline-flex items-center gap-1 px-3 py-1 bg-primary-500/10 rounded-full text-xs font-bold text-primary-500">
                  <span className="w-1.5 h-1.5 bg-primary-500 rounded-full animate-pulse" />
                  CANLI
                </span>
              </div>
              <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-50 tracking-tighter mb-4">
                SEKTÖR TRENDLERİ
              </h1>
              <p className="text-sm md:text-base text-foreground-400 font-medium max-w-xl speakable-summary">
                Dijital pazarlama dünyası sürekli değişiyor. BIFF Digital olarak sektör trendlerini yakından takip ediyor, müşterilerimizin stratejilerini her zaman bir adım önde tutuyoruz.
              </p>
            </div>

            {/* Category Filter */}
            <div className="flex flex-wrap items-center gap-2 mb-10 md:mb-14">
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => setActiveCategory(cat)}
                  className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                    activeCategory === cat
                      ? 'bg-primary-500 text-foreground-950'
                      : 'bg-background-100 text-foreground-400 hover:text-foreground-50 hover:bg-background-200'
                  }`}
                >
                  {cat}
                </button>
              ))}
            </div>

            {/* Timeline */}
            <div className="relative">
              <div className="absolute left-6 md:left-8 top-0 bottom-0 w-px bg-background-200" />

              {filteredInsights.length === 0 ? (
                <div className="pl-16 md:pl-20 py-16 text-center">
                  <p className="text-sm md:text-base text-foreground-400">
                    Bu kategoride henüz içerik yok. Çok yakında ekleyeceğiz.
                  </p>
                </div>
              ) : (
                <div className="space-y-8 md:space-y-10">
                  {filteredInsights.map((item, idx) => (
                    <article key={idx} className="relative pl-16 md:pl-20">
                      <div className="absolute left-[22px] md:left-[30px] top-1 w-3 h-3 bg-primary-500 rounded-full ring-4 ring-background-50" />

                      <div className="glass-card-hover rounded-2xl p-5 md:p-6">
                        <div className="flex flex-wrap items-center gap-3 mb-3">
                          <span className="text-xs font-bold text-foreground-500">{item.date}</span>
                          <span className="px-2.5 py-0.5 bg-primary-500/10 rounded-full text-xs font-bold text-primary-500">
                            {item.tag}
                          </span>
                        </div>
                        <h2 className="text-base md:text-lg font-bold text-foreground-50 mb-2">
                          {item.title}
                        </h2>
                        <p className="text-sm text-foreground-400 leading-relaxed">
                          {item.desc}
                        </p>
                      </div>
                    </article>
                  ))}
                </div>
              )}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="section-padding bg-background-100">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="glass-card rounded-2xl p-6 md:p-10 text-center">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
                Stratejinizi Güncelleyelim
              </h2>
              <p className="text-sm md:text-base text-foreground-400 mb-8 max-w-xl mx-auto">
                Dijital dünya hızla değişiyor. Mevcut stratejinizin hala işe yarayıp yaramadığını ücretsiz analiz edelim. Size özel güncel bir yol haritası çıkaralım.
              </p>
              <a href="/#contact" className="btn-primary">
                Ücretsiz Analiz
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}